import React, { useState, useEffect } from 'react';

const TodayCounter: React.FC = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    const storageKey = `today_count_${today}`;
    const stored = localStorage.getItem(storageKey);
    const base = stored ? parseInt(stored, 10) : Math.floor(Math.random() * 300) + 200;

    if (!stored) {
      localStorage.setItem(storageKey, String(base));
    }

    const newCount = base + 1;
    localStorage.setItem(storageKey, String(newCount));
    setCount(newCount);
  }, []);

  if (count === 0) return null;

  return (
    <div style={{
      fontSize: '13px',
      color: '#888',
      margin: '8px 0 16px 0',
    }}>
      🔥 오늘 <span style={{ fontWeight: 'bold', color: '#FF6B6B' }}>{count.toLocaleString()}</span>명이 테스트했어요
    </div>
  );
};

export default TodayCounter;
